var Marionette = require('marionette')
var Backbone = require('backbone')
var App = require('app')
var _ = require('lodash')

// Omit disabled inputs from being processed by syphon
Backbone.Syphon.KeyAssignmentValidators.registerDefault(function (el, key, value) {
  let input = el[0]
  if (!input) return false
  return (!input.disabled)
})

var EditNewController = Marionette.Object.extend({
  onDelete: function (data) {
    var self = this

    // check if this is a bulk action or not
    if (self.options.bulkAction) {
      self.processBulkDelete(self.view.collection, function (err, response) {
        if (err) {
          App.dialog.alert({
            unsafeMessage: '<h3>The items could not be deleted.</h3>' + err.responseJSON.message
          })
        }
        self.region.empty()
      })

    } else {

      var model = data.model
      var collection = model.collection
      var isPaginatedCollection = _.has(collection, 'state')

      this.deleteConfirmation(model, function (err, confirmed) {
        if (err) return false
  
        return model.destroy({
          success: function () {
            self.region.empty()
            if (isPaginatedCollection) collection.getPreviousPage()
          }
        })
      })
    }

  //  console.log(model)


  // if (confirm('Are you sure you want to delete: ' + (model.get('name')))) {
  //   return model.destroy({
  //     success: function () {
  //       _this.region.empty()
  //     }
  //   })
  // } else {
  //   return false
  // }
  },
  onDeleteMessage: function (model, message) {
    return message
  },
  deleteConfirmation: function (model, callback) {
    var message = 'Are you sure you want to delete this item?'
    var dialogMessage = this.onDeleteMessage(model, 'Are you sure you want to delete this item?')
    if (!dialogMessage) dialogMessage = message

    App.dialog.confirm({
      message: dialogMessage,
      callback: function (confirmed) {
        if (confirmed) {
          return callback(null, true)
        } else {
          return callback(true)
        }
      }
    })
  },
  formSubmit: function (data) {
    var self = this
    var data = Backbone.Syphon.serialize(this.view)
    // console.log(self.view.model.validate())

    // determine if this is a regular save or a bulk action
    if (self.options.bulkAction) {
      let preparedData = self.formBulkPreSave(self.view.model, self.view.collection, data)
      self.processBulkPatch(preparedData, self.view.model, self.view.collection, function () {
        self.region.empty()
      })
    } else {
      let preparedData = self.formPreSave(self.view.model, data)
      self.processFormSubmit(preparedData, self.view.model, self.view.collection, function () {
        self.region.empty()
      })
    }
  },
  formBulkPreSave: function (model, collection, data) {
    return data
  },
  formPreSave: function (model, data) {
    return data
  },
  processBulkPatch: function (data, model, collection, callback) {
    if (!data) return

    // remove any empty values
    var compacted = _.clone(data)

    App.dialog.confirm({
      message: 'Are you sure you want to perform an operation on ' + collection.getBulkCount() + ' items?',
      callback: function (confirmed) {
        if (confirmed) {
          // perform a bulk patch
          return collection.bulkPatch(compacted, {
            updateCollection: true,
            callback: callback
          })
        }
      }
    })
  },
  processBulkDelete: function (collection, callback) {
    App.dialog.confirm({
      message: 'Are you sure you want to perform an operation on ' + collection.getBulkCount() + ' items?',
      callback: function (confirmed) {
        if (confirmed) {
          // perform a bulk patch
          return collection.bulkDelete({
            updateCollection: true,
            callback: callback
          })
        }
      }
    })
  },
  processFormSubmit: function (data, model, collection, callback) {
    if (!data) return
    var isNew = model.isNew()

    return model.save(data, {
      patch: true,
      collection: collection,
      error: function (model, response) {
        App.dialog.alert({
          unsafeMessage: '<h3>The item could not be saved.</h3>' + response.responseJSON.message
        })
        callback(new Error(), response.responseJSON.message)
      },
      success: function (model, response) {
        // when the model isNew and this is a paginated collection, don't add the
        // model to the collection because it will be added to the current page
        var addToCollection = true

        var currentPage = _.get(collection, 'state.currentPage')
        var lastPage = _.get(collection, 'state.lastPage')

        var isPaginatedCollection = _.has(collection, 'state')

        // if this is the last page don't add the item to the current page
        if (isPaginatedCollection && currentPage < lastPage) addToCollection = false

        // if this is a paginated collection
        // add the item to the collection to update the views
        if (isNew && collection && addToCollection) collection.add(model)

        // reset the pagination
        if (isPaginatedCollection) collection.getPage(currentPage)

        callback(null, response)
      }
    })
  }
})

module.exports = EditNewController



// WEBPACK FOOTER //
// ./js/components/edit_new-controller.js